import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshConceptService {

  private refreshSubject = new Subject<{ id: number; type: string }>();

  refresh$ = this.refreshSubject.asObservable();

  emitRefresh(id: number, type: string): void {
    this.refreshSubject.next({ id, type });
  }
}
